import React from 'react';
import * as S from './FillingFast.styles';

const FillingFast = ({ fast_persuasion }) => {
    const { title, icon, url, tc } = fast_persuasion;

    return (<>
        {title && url ?
            <S.FillingFastSection>
                {url ? <img src={url} alt={icon} /> : <></> }
                <S.TextSection colorCode={tc ? tc : 'none'}>{title}</S.TextSection>
            </S.FillingFastSection>
            : <></>}
    </>)
}

export default FillingFast;
